import { observer } from 'mobx-react'
import { useMemo } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { ColumnFilterProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFilterOptionsStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFilterOptionsStore'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import { CaseFilterIds } from '@new/domains/operations/screens/CasesV2/utils/config'

import * as S from './commonFilterStyles.style'

const _PropertyFilter = (props: ColumnFilterProps) => {
  const { properties, setFilterValue } = casesFiltersStore
  const { propertiesOptions, isLoadingProperties } = casesFilterOptionsStore

  const handleDataFilter = (value?: string[] | undefined) => {
    setFilterValue(CaseFilterIds.Property, value)
  }

  const computedOptions = useMemo(() => {
    const newList = propertiesOptions.map(property => ({
      ...property,
      group: properties?.some((selectedOption: string) => selectedOption === property.value)
        ? ''
        : property.group,
    }))

    return newList.sort((a, b) => {
      if (a.group === '' && b.group !== '') return -1
      if (a.group !== '' && b.group === '') return 1
      return a.group.localeCompare(b.group)
    })
  }, [propertiesOptions, properties])

  return (
    <S.CheckBoxWrapper optionsLength={computedOptions.length}>
      <CheckboxBasedFilter
        shouldGroupBy
        isLoadingOptions={isLoadingProperties}
        title="Properties"
        options={computedOptions}
        initialValue={properties}
        onChange={handleDataFilter}
        alwaysShowAll
        shouldShowClearButton
        {...props}
      />
    </S.CheckBoxWrapper>
  )
}

export const PropertyFilter = observer(_PropertyFilter)
